var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "p-3" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                [
                  _vm.$route.meta.action.c
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.updateDialog = true
                              _vm.form.name = ""
                              _vm.form.id = null
                              _vm.form.description = ""
                              _vm.form.uniformNum = "00000000"
                              _vm.edit = false
                            },
                          },
                        },
                        [_vm._v(" 新增 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", {}),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.companies, stripe: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: "名稱", width: "300" },
          }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "說明" },
          }),
          _c("el-table-column", {
            attrs: { prop: "mvmCount", label: "機台數量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.mvmCount) + " ")]
                },
              },
            ]),
          }),
          _vm.$route.meta.action.u
            ? _c("el-table-column", {
                attrs: { label: "動作" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.updateDialog = true
                                  _vm.form.name = scope.row.name
                                  _vm.form.id = scope.row.id
                                  _vm.form.uniformNum = scope.row.uniformNum
                                  _vm.form.description = scope.row.description
                                  _vm.edit = true
                                },
                              },
                            },
                            [_vm._v("編輯")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  417723920
                ),
              })
            : _vm._e(),
          _vm.$route.meta.action.u
            ? _c("el-table-column", {
                attrs: { label: "聯絡人" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.profileDialog = true
                                  _vm.selectCompanyID = scope.row.id
                                },
                              },
                            },
                            [_vm._v("聯絡人")]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3988103676
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.profileDialog },
          on: {
            "update:visible": function ($event) {
              _vm.profileDialog = $event
            },
          },
        },
        [
          _vm.profileDialog
            ? _c("profile", { attrs: { company_id: _vm.selectCompanyID } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { title: "經銷商", visible: _vm.updateDialog },
          on: {
            "update:visible": function ($event) {
              _vm.updateDialog = $event
            },
            closed: function ($event) {
              _vm.collapse = 2
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { rules: _vm.rules, model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "經銷商名稱", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "經銷商說明" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", autocomplete: "off" },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "統一編號" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.form.uniformNum,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "uniformNum", $$v)
                      },
                      expression: "form.uniformNum",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.edit
            ? _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.collapse,
                    callback: function ($$v) {
                      _vm.collapse = $$v
                    },
                    expression: "collapse",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("template", { slot: "title" }, [
                        _c("div", { staticClass: "text-danger" }, [
                          _vm._v(" 危險動作 "),
                          _c("i", {
                            staticClass: "header-icon el-icon-warning",
                          }),
                        ]),
                      ]),
                      _c(
                        "el-popconfirm",
                        {
                          attrs: { title: "確定刪除?" },
                          on: {
                            confirm: function ($event) {
                              return _vm.deleteItem(_vm.form.id)
                            },
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { slot: "reference", type: "danger" },
                              slot: "reference",
                            },
                            [_vm._v("刪除經銷商")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.updateDialog = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.update } },
                [_vm._v("確定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }